import { render } from "./AddPointBottomMenu.vue?vue&type=template&id=b6cceeb6&scoped=true"
import script from "./AddPointBottomMenu.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./AddPointBottomMenu.vue?vue&type=script&charset=utf-8&lang=js"

import "./AddPointBottomMenu.vue?vue&type=style&index=0&id=b6cceeb6&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6cceeb6"]])

export default __exports__